import { apiCall, apiCallWithoutAuth } from "./firebase";
import { FirebaseMessage, Thread } from "../types";
import { googleAuthService } from "./googleAuth";

// Example of how to use the new authentication system:
// Instead of using apiCall, you can use googleAuthService.makeAuthenticatedRequest
// for Google Calendar API calls that automatically handle token refresh

export class MessageService {
  // Get all threads for the current user
  static async getUserThreads(): Promise<Thread[]> {
    try {
      const currentUser = googleAuthService.getCurrentUser();
      if (!currentUser) {
        console.log("No user logged in, returning empty threads");
        return [];
      }

      // For now, return empty array since we need to update the backend
      // to handle Google OAuth users properly
      console.log("User logged in with Google OAuth, returning empty threads for now");
      return [];

      // TODO: Update backend to handle Google OAuth authentication
      // const response = await apiCallWithoutAuth(`/getUserThreads?userId=${currentUser.id}`);
      // return response.threads || [];
    } catch (error) {
      console.error("Error fetching user threads:", error);
      return [];
    }
  }

  // Get unread messages for the current user
  static async getUnreadMessages(): Promise<FirebaseMessage[]> {
    try {
      const response = await apiCall("/getUnreadMessages");
      return response.messages || [];
    } catch (error) {
      console.error("Error fetching unread messages:", error);
      return [];
    }
  }

  // Send a message
  static async sendMessage(threadId: string, content: string, sender: "user" | "agent"): Promise<FirebaseMessage> {
    try {
      const response = await apiCall("/sendMessage", {
        method: "POST",
        body: JSON.stringify({
          threadId,
          content,
          sender,
        }),
      });
      return response.message;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  }

  // Mark a message as read
  static async markMessageAsRead(messageId: string): Promise<void> {
    try {
      await apiCall("/markMessageAsRead", {
        method: "POST",
        body: JSON.stringify({ messageId }),
      });
    } catch (error) {
      console.error("Error marking message as read:", error);
      throw error;
    }
  }

  // Get messages for a specific thread
  static async getThreadMessages(threadId: string, limit = 50): Promise<FirebaseMessage[]> {
    try {
      const response = await apiCall(`/getThreadMessages?threadId=${threadId}&limit=${limit}`);
      return response.messages || [];
    } catch (error) {
      console.error("Error fetching thread messages:", error);
      return [];
    }
  }

  // Create a new thread
  static async createThread(agentId: string): Promise<Thread> {
    try {
      const response = await apiCall("/createThread", {
        method: "POST",
        body: JSON.stringify({
          agentId,
        }),
      });
      return response.thread;
    } catch (error) {
      console.error("Error creating thread:", error);
      throw error;
    }
  }
}
